import { render, staticRenderFns } from "./groupsending.vue?vue&type=template&id=3626f976&scoped=true&"
import script from "./groupsending.vue?vue&type=script&lang=js&"
export * from "./groupsending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3626f976",
  null
  
)

export default component.exports